import styled from "styled-components";

export const HeaderSection = styled.div`
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 20px;
    cursor: default;
`; 